import React, { ReactElement } from "react";
import { useSelector } from "react-redux";
import moment from "moment-timezone";
import { Link } from "react-router-dom";
import * as Middleware from "@middlewares/index";

interface IProps {
  type: string;
  standId: number;
  imageUrl: string;
  companyLogoUrl: string;
  title: string;
  description?: string;
  contacts: any[];
  url?: string;
}

const NetworkingStand = ({
  type,
  standId,
  imageUrl,
  companyLogoUrl,
  title,
  description,
  contacts,
  url,
}: IProps): ReactElement => {
  const workshopData = useSelector((state: any) => state.Main.Workshop.data);
  const registerEndAt = moment(workshopData.registerEndAt)
    .tz("Europe/Moscow")
    .format();
  const now = moment().tz("Europe/Moscow").format();
  const netwDays = useSelector((state) => state.Networking?.Days.data);

  const handleClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    if (now > registerEndAt) {
      event.preventDefault();
      Middleware.Ui.Modal.open("RegistrationClosed", { callback: "" });
    }
  };

  return (
    <div className={`netw-card netw-card--${type}`}>
      {(type === "general" || type === "platinum" || type === "gold") && (
        <Link
          className="netw-card__bg"
          to={`/company${type !== "bronze" ? "/stand" : ""}/${standId}`}
        >
          {imageUrl !== null && <img src={imageUrl} alt={title} />}
        </Link>
      )}

      <div className="netw-card__body">
        {(type === "general" ||
          type === "platinum" ||
          type === "gold" ||
          type === "silver") && (
          <Link to={`/company/stand/${standId}`} className="netw-card__logo">
            {companyLogoUrl ? (
              <img src={companyLogoUrl} alt={title} />
            ) : (
              <img
                src={require("@public/images/defaultAvatarCompany.svg")}
                alt={title}
              />
            )}
          </Link>
        )}

        <div className="netw-card__content">
          <Link
            to={`/company${type !== "bronze" ? "/stand" : ""}/${standId}`}
            className="netw-card__title"
          >
            {title}
          </Link>
          {(type === "general" || type === "platinum") && (
            <p className="netw-card__desc">{description}</p>
          )}

          <Link
            className="netw-card__more-link"
            to={`/company${type !== "bronze" ? "/stand" : ""}/${standId}`}
          >
            Подробнее
          </Link>
        </div>
        <div className="netw-card__footer">
          {contacts.length > 0 &&
          (type === "general" || type === "platinum" || type === "gold") ? (
            <div className="netw-card__contacts">
              <p className="netw-card__contacts-title">Представители:</p>
              <ul className="netw-card__contacts-list">
                {contacts.map((item: any, index: number) => {
                  return (
                    index < 3 && (
                      <li className="netw-card__contacts-item" key={index}>
                        {item.image !== null && (
                          <img src={item.image} alt={item.fullName} />
                        )}
                      </li>
                    )
                  );
                })}
                {contacts.length > 3 && type === "general" && (
                  <li className="netw-card__contacts-item netw-card__contacts-item--counter">
                    +{contacts.length - 3}
                  </li>
                )}
              </ul>
            </div>
          ) : null}

          <div className="netw-card__buttons">
            {netwDays?.length ? (
              <Link
                className="btn btn--red"
                to={`/company${type !== "bronze" ? "/stand" : ""}/${standId}`}
                onClick={(event) => {
                  handleClick(event);
                }}
              >
                Назначить встречу
              </Link>
            ) : null}

            <Link
              className="btn btn--red"
              to={`/company${type !== "bronze" ? "/stand" : ""}/${standId}`}
              onClick={(event) => {
                handleClick(event);
              }}
            >
              Отправить визитку
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NetworkingStand;
